export const PUBLIC_KEY = "fbd74d3934952595380700ceca5d2d";
export const ENVIRONMENT = "sandbox";
